import { getYearFromDate, titleCaseToReadable } from '../../utils/utility';

import { TableCell, TableRow, Typography } from '@mui/material';
import {
  Lead,
  LeadPreviewFragment,
  LeadStatusEvent,
  useCloseLeadsMutation
} from '../../generated/hooks_and_more';
import { useNavigate } from 'react-router-dom';
import format from 'date-fns/format';
import DeleteIcon from '@mui/icons-material/Delete';

type TaskListProps = {
  regNo: string;
  pendingOn: string;
  currentStatus: string;
  make: string;
  title: string;
  lseId:string;
  createdAt: string;
  index?: number;
  taskPerformBy: string;
};

function TaskListRow(props: TaskListProps) {
  const {
    regNo,
    pendingOn,
    currentStatus,
    make,
    title,
    createdAt,
    taskPerformBy,
    lseId
  } = props;

  const nav = useNavigate();
  const performBy = `${currentStatus ?? '-'} By ${taskPerformBy}`;

  return (
    <TableRow
      hover
      onClick={() => {
        nav(`/vms-admin/leads/${regNo}`, {
            state:{lseId:lseId}
        });
      }}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell title={regNo ?? ''} sx={{ maxWidth: '180px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
        >
          {regNo ?? '-'}
        </Typography>
      </TableCell>

      <TableCell title={currentStatus} sx={{ maxWidth: '180px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
          title={performBy}
        >
          {titleCaseToReadable(performBy)}
        </Typography>
      </TableCell>
      <TableCell title={pendingOn} sx={{ maxWidth: '180px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
          title={pendingOn}
        >
          {titleCaseToReadable(pendingOn) ?? '-'}
        </Typography>
      </TableCell>
      <TableCell sx={{ maxWidth: '170px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
          title={title}
        >
          {titleCaseToReadable(title)}
        </Typography>
      </TableCell>

      <TableCell title={make ?? ''} sx={{ maxWidth: '100px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
        >
          {make ?? '-'}
        </Typography>
      </TableCell>
      <TableCell sx={{ maxWidth: '140px' }}>
        <Typography
          variant="body1"
          fontSize="13px"
          color="text.primary"
          gutterBottom
          noWrap
        >
          {createdAt}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default TaskListRow;
